import React from 'react'
// import { Route } from 'react-router-dom';
import PrivateRoute from '../components/privateRoute'
import Dashboard from '../pages/dashboard'
import FinanceOverview from '../pages/companyP&L/financeOverview'
import ApprovalForManualTransaction from '../components/approvalForManualTransaction'
// import ChangePasswordScreen from '../components/changePasswordScreen'
import CustomerInformation from '../components/customerInformation'
import OptimasationFilesView from '../pages/optimisationFiles/view'
import OptimasationFilesUpload from '../pages/optimisationFiles/upload'
import OpenPo from '../pages/companyP&L/openPos'
import BOM from '../pages/bom'
import StoreStocks from '../pages/store/stocks'
import ProjectDocuments from '../pages/design/projectDocuments'
// import SendToFinance from '../pages/design/sendToFinance'
import FinanceApprove from '../pages/finance'
import RawLeads from '../components/rawLeads'
import Scoping from '../pages/scoping'
import Inwarding from '../pages/inwarding'
import ApprovePoSo from '../pages/companyP&L/approvePoSoMtr'
import ApprovePayments from '../pages/companyP&L/approvePayments'
import StorePayment from '../pages/store/payment'
import User from '../pages/userManagement/users'
import Roles from '../pages/userManagement/roles'
import Department from '../pages/userManagement/departments'
import Team from '../pages/userManagement/teams'
import Vendors from '../pages/vendorManagement/vendors'
import FactoryPayment from '../pages/factory/payment'
import FactoryStocks from '../pages/factory/stocks'
import MaterialTransfer from '../pages/materialTransfer'
import ManageCategory from '../pages/masterManagement/manageCategory'
import ManageScopes from '../pages/masterManagement/manageScopes'
import ManageUnits from '../pages/masterManagement/manageUnits'
import ManagePaymentModes from '../pages/masterManagement/managePaymentModes'
import ManageSubCategory from '../pages/masterManagement/manageSubCategory'
import ManageItems from '../pages/masterManagement/manageMaterials'
import ManageOrgRate from '../pages/masterManagement/manageOrgRate'
import InwardingForProjects from '../pages/companyP&L/inwarding'
import InwardingForFactory from '../pages/factory/inwarding'
import InwardingForStore from '../pages/store/inwarding'
import FactoryOutwarding from '../pages/factory/outwarding'
import StoreOutwarding from '../pages/store/outwarding'
import QTProject from '../pages/qtProjects'
import Storelead from '../pages/storelead'
import ManageQTCustomer from '../pages/manageQTCustomer'
import ManageQuotation from '../pages/manageQuotation'
import ApproveVendorAndMaterialMapping from '../pages/vendorManagement/approveVendorAndMaterialMapping'
import manageProjectLog from '../pages/manageProjectLog'
import createLead from '../pages/leadCreation'
import createNewCustomer from '../pages/leadCreationCustomer'
import marketingSource from '../pages/masterManagement/marketingSource'
import discountApproval from '../pages/discountApproval'
import marketingBudget from '../pages/marketingBudget'
import ShowStatusInformation from '../components/showStatusInfo'
import ManageProjectRate from '../pages/masterManagement/manageProjectRate'
import manageTarget from '../pages/masterManagement/manageTarget'
import managerCustomer from '../pages/customers/managerCustomer'
import ReminderReport from '../pages/reminder'
import Home from '../pages/home'
import AssignProjects from '../pages/customers/assignProject';
import MoveToDesign from '../pages/customers/moveToDesign';
import Location from '../pages/location'
import ExperienceCenter from '../pages/experienceCenter'
import DesignerAssignmentView from '../components/designerAssignmentView';
import leadApprovalView from '../components/leadApprovalView';
import ComplimentaryApprovalView from '../components/complimentaryApprovalView'
import CheckLists from '../components/checkList';
import manageDiscount from '../pages/masterManagement/manageDiscount';
import vendorPo from '../pages/vendorManagement/vendorPo'
import AllPo from '../pages/vendorManagement/vendorPo/allPo'

import BomMaterialForApproval from '../pages/bom/bomMaterialForApproval'
import LeadDesignToExecution from '../components/leadDesignToExecution';
import ContractSignLeads from '../pages/contractSignLead';
import VerifyDocuments from '../components/verifyDocuments';
import ValidateContractsDocuments from '../components/validateContractDocuments';
import SiteQcProjects from '../pages/siteQCProject';
import ManageSiteQcProjectLogs from '../pages/siteQCProject/projectlog';
import ReadyToDispatchProject from '../pages/readyToDispatchProject/projects';
import ManageReadyToDispatchProjectLogs from '../pages/readyToDispatchProject/projectLogs'
import ManageExecutionProjectLogs from '../pages/underExecution/projectlog'
import ViewCustomerCheckList from '../pages/viewChecklist';
import ProjectMaterilData from '../pages/siteQCProject/projectMaterial';
// import ViewCustomerCheckList from '../pages/viewChecklist';
// import TermsAndCondition from '../components/termAndCondition';
import TargetDetails from '../components/target-details';
import StageWiseLeads from '../components/stagewiseleads'
import customerSurveyFormsList from '../pages/customerSurveyFormsList'

import Material_Return from '../pages/material/Material_Return'
import Approve_Material_Return from '../pages/material/Approve_Material_Return'
import RealFormDetails from '../pages/customerSurveyFormDetails';
import AddEditCheckList from '../pages/checklist';
import FinalPaymentApproval from '../components/finalPaymentApproval';
import ImosCompletedProjects from '../pages/siteQCProject/imosCompletedProject';
import imosDashboardStageDetails from '../components/imosDashboardStageDetails'
import ExecutionDashBoardDetail from '../components/executionDashBoardDetail'
import ExecutionDashBoardProjectDetail from '../components/executionDashBoardProjectDetails'
import DesignDashBoard from '../components/designstatistics'
import ContractLeads from '../components/contractlead'
import CHMLeads from '../pages/chmLeads'
import ChmUserLeads from '../pages/chmUserLeads'
import UnderExecutionProject from '../pages/underExecution/projects'
import Completed from '../pages/underExecution/projectcompleted'
import CompletedMWP from '../pages/underExecution/projectCompletedMWP'
import OperationOne from '../components/operationsOne';
// import DesignKickOff from '../pages/design_kick-off;
import DesignKickOff from '../pages/design_kick-off'
import SkpApprovals from '../pages/skpApprovalsPage'
import { useSelector } from 'react-redux';
import { ROLENAME } from '../utils/index';
import vendorSOManage from '../pages/vendorSOManage'
import callCenterLogs from '../components/callCenterLogs'
import InwardingInvoices from '../pages/InwardingInvoices/InwardingInvoices'
import ProjectCompletionStats from '../pages/StatisticsReport/ProjectCompletionStats'
import DesignSignOffStats from '../pages/StatisticsReport/DesignSignOffStats'
import MaterialDeliveryStats from '../pages/StatisticsReport/MaterialDeliveryStats'
import BookingStats from '../pages/StatisticsReport/BookingStats'
import MIS1 from '../pages/mis1/index'
import LeadsGenerated from '../pages/leadsGenerated/index'
import SourceOfLeadsDasboard from '../pages/sourceOfLeadsDashboard/index'
import SalesSummary from '../pages/salesSummary/index'
import DesignSummary from '../pages/designSummary/index'
import InternalDSOSummary from '../pages/internalDesignSignOff/index'
import LostDataAnalysis from '../pages/lostDataAnalysis/index'
import DesignSignOffReview from '../pages/designSignOffReview/index'
import DesignHoldAnalysis from '../pages/designHoldAnalysis/index'
import MonthlyContractReview from '../pages/monthlyContractReview/index'
import OpsReview from '../pages/opsReviewDashboard/index'
import PreProductionSummary from '../pages/preProductionSummary/index'
import ProductionSummary from '../pages/productionSummary/index'
import SummaryOfDelivery from '../pages/summaryOfDelivery/index'
import UnderExecutionSummary from '../pages/underExecutionSummary/index'
import MWPSummary from '../pages/mwpSummary/index'
import SummaryOfCompletion from '../pages/summaryOfCompletion/index'
import StageValue from '../pages/stageValue/index'
import paymentApprover from '../components/paymentApprover'
import paymentDetails from '../components/paymentDetails'
import hdfcVPC from '../components/hdfcVPC'
// import pendingInwardingApprovals from '../pages/pendingInwardingApprovals'
// import MultiCheckCreatePo from '../components/MultiCheckCreatePo'
import customerInformation from '../components/customerInformation'
import MultiCheckCreatePo from '../components/MultiCheckCreatePo'
import PaymentGenrateLink from '../components/PaymentGenrateLink'
import WorkingDrawingReceived from '../components/WorkingDrawingReceived'
import FactoryReviewSheet from '../pages/FactoryReviewSheet'
import QtChangesApproval from '../pages/QtChangesApproval'
import LostLeadApprovalView from '../components/LostLeadApprovalView'
import chmTicketForm from '../pages/chmTicketForm'
import CHMuserDashboard from '../pages/CHMuserDashBoard'
import ChmAddTicketCategory from '../components/chmAddTicketCategory'
import CustomerLoginActivity from '../pages/cx_customer/customerLoginActivity'
import DesignHoldView from '../components/DesignHoldView'
import UserAccessManagement from '../components/userAccessMangement'
import leadToMeeting from '../components/leadToMeeting'
import leadToOrder from '../components/leadToOrder'
import meetingToOrder from '../components/meetingToOrder'
import leadInMarketing from '../components/leadInMarketing'
import leadCriteria from '../components/leadCriteria'
import FaqCreation from '../components/faqCreation'
import CxStageSetting from '../pages/cxStageSetting'
import WhatsApp_Stages_Operations from '../pages/whatsapp_stages_operations'
import WhatsApp_Stages_Marketing from '../pages/whatsapp_stages_marketing'
import WhatsApp_Stages_Sales from '../pages/whatsapp_stages_sales'
import downloadCenter from '../components/downloadCenter'
import DesignHoldApprovalView from '../components/designHoldApproval.js';
import ApprovedPaymentReceivedAnalysis from '../pages/ApprovedPaymentReceivedAnalysis/index.js'
import KnowLedgeHub from '../components/knowLedgeHub'
import callCenterDashboard from '../components/callCenterDashboard.js'
import TaskManagementDashBoard from '../pages/TaskManagementDashBoard'
import RefundRequestApprovalView from '../components/refundRequestApprovalView'
import RaiseRefundRequest from '../components/raiseRefundRequest'
import RaiseQuotationChangeRequest from '../pages/raiseQuotationChangeRequest'
import RefundApproval from '../components/refundApproval'
import GenerateBarcode from '../components/generateBarcode.js'
import ScanBarcode from '../components/scanBarcode.js'
import DesignHoldRevokeAnalysis from '../pages/designHoldRevokeAnalysis/index'
import SalesTarget from "../components/SalesTarget.js";
import PerformanceSales from "../components/PerformanceSales.js";
import NewInwardingApprovals from "../pages/NewInwardingApprovals/index.js";
import PendingInwardingApprovals from "../pages/PendingInwardingApprovals/index.js";
import EditedInwardingApprovals from "../pages/EditedInwardingApprovals/index.js";
import RaisePaymentRequests from "../pages/RaisePaymentRequests/index.js";
import RejectedInwarding from "../pages/RejectedInwarding/index.js";
import POEditRequests from '../pages/POEditRequests/index.js';
import PaymentRequestApproval from '../pages/PaymentRequestApproval/index.js'
import InwardingFreightApproval from '../pages/InwardingFreightApproval/index.js';
import PaymentExcelDownload from '../pages/PaymentExcelDownload/index.js';
import FactoryFinanceExecutive from '../pages/FactoryFinanceExecutive/index.js';
import DownloadGRN from '../pages/DownloadGRN/index.js';
import POEditRequestsL1 from '../pages/POEditRequestsL1/index.js';
import ParentComponent from '../pages/LeadBuilder/Assembly.js'
import StageReview from '../pages/stageReview/index';
import leadsAssigned from '../components/leadsAssigned'
import CurrentMonthPipelineDashboard from '../pages/currentMonthPipelineDashboard/index';
import ProjectionAcvDashboard from '../pages/projectionAcvDashboard/index'
import MeetingTrackerDashboard from '../pages/meetingTrackerDashboard'
import ExpectedClosureTracker from '../pages/expectedClosureTracker';
import ReminderDashboard from '../pages/reminderDashboard'
import Incentives from '../components/Incentives.js'
import TeamUserLogs from '../pages/teamUserLogs/index.js'
import MoveToMarketingApproval from '../pages/moveToMarketingApproval/index.js'
import ProjectManagementDashboard from '../components/ProjectManagementDashboard.js'
import CreateProject from '../components/CreateProject.js'
import SalesUserHomePage from '../pages/salesUserHomePage'
import TaskManagementNotesDashboard from '../pages/TaskManagementNotesDashboard'
import MaterialPriceChangeDetails from "../pages/MaterialPriceChangeDetails/index.js";
import SalesUserWonDealPending from '../components/SalesUserWonDealPending'
import Referral from '../components/Referal.js'
import SalesUserLeadMetrics from '../pages/SalesUserLeadMetrics'
import CallRecordings from '../pages/callRecordings/index';
import CallLogsForLead from '../pages/callRecordings/leadCallLogs';
import MaterialsCheckListApprovals from '../pages/materialsChecklistApprovals'
import ApproveStdRateOfMaterial from '../components/ApproveStdRateOfMaterial'
import Reports from '../components/Reports'
import IncomingWhatsAppMessages from '../components/IncomingWhatsAppMessages.js'
import TargetForDesignTeam from "../components/TargetForDesignTeam.js"
import PerformanceForDesignTeam from '../components/PerformanceForDesignTeam.js'
import IncentiveForDesignTeam from '../components/IncentiveForDesignTeam.js'
import MyProjectManagementDashboard from '../components/MyProjectManagementDashboard.js'
import CapexProjectCreation from '../components/CapexProjectCreation.js'
import CapexProjectApproval from '../components/CapexProjectApproval.js'
import OverheadProjectApproval from '../components/OverheadProjectApproval.js'
import OverheadProjectCreation from '../components/OverheadProjectCreation.js'
import InTransit from '../pages/readyToDispatchProject/inTransit/index.js'
import ScanPackageReport from '../components/scanPackageReport.js'
import ScanPiece from '../components/scanPiece.js'
import AutomationLeadDashboard from '../pages/automationLeadDashboard/index';
import RedirectEC from '../pages/redirectEC/index';
import logDetailed from "../pages/logDetailed/logDetailed.js"
import MonthlyConversionGoals from '../components/MonthlyConversionGoals.js'
import inwardingLockDate from '../components/inwardingLockDate.js'


const Index = () => {
	const { userDetails } = useSelector(state => state.user)
	return (
		<>
			{userDetails.roles.find(role=> role.name === ROLENAME.SalesUser) ? 
				<PrivateRoute component={SalesUserHomePage} path="/dashboard" exact />
			  :
				<PrivateRoute component={Dashboard} path="/dashboard" exact />
			}	
			<PrivateRoute component={SalesUserLeadMetrics} path="/lead-metrics" exact />
			<PrivateRoute component={SkpApprovals} path="/skpApprovals" exact />
			<PrivateRoute component={GenerateBarcode} path="/generate-barcode" exact />
			<PrivateRoute component={ScanBarcode} path="/scan-barcode" exact />
			<PrivateRoute component={downloadCenter} path="/download-center" exact />
			{/* Start - Payment Integration */}
			<PrivateRoute component={paymentDetails} path="/paymentDetails" exact />
			<PrivateRoute component={hdfcVPC} path="/hdfc-virtual-payment" exact />
			{/* End - Payment Integration */}
			<PrivateRoute component={KnowLedgeHub} path="/knowledge_hub" exact />
			<PrivateRoute component={DesignDashBoard} path="/designstats" exact />
			<PrivateRoute component={ContractLeads} path="/contractleads" exact />
			<PrivateRoute component={QTProject} path="/qtProjects" exact />
			<PrivateRoute component={FinanceOverview} path="/companyP&L/financeOverview" exact />
			<PrivateRoute component={CustomerInformation} path="/financeApprovalScreen&L/customerInformation" exact />
			<PrivateRoute component={ApprovalForManualTransaction} path="/financeApprovalScreen&L/approvalForManualTransaction" exact />
			<PrivateRoute component={ApprovedPaymentReceivedAnalysis} path="/financeApprovalScreen&L/approved-payment-receipts" exact />
			{/* <PrivateRoute component={ChangePasswordScreen} path="/change_password" exact /> */}
			{/* <Route component={ChangePasswordScreen} path="/change_password" exact /> */}
			<PrivateRoute component={OptimasationFilesView} path="/optimisation_files/view" exact />
			<PrivateRoute component={OptimasationFilesUpload} path="/optimisation_files/upload" exact />
			{
				(userDetails.roles?.find(role =>role.name === "Operation Head" || role.name === "Finance Executive" || role.name === "Finance Manager") && 
				<>
			<PrivateRoute component={ApprovePoSo} path="/companyP&L/approvePoSoMtr" exact />
			   </>
				)
			}			
			<PrivateRoute component={ApprovePayments} path="/companyP&L/approvePayments" exact />
			<PrivateRoute component={RawLeads} path="/raw-leads" exact />
			<PrivateRoute component={InwardingForProjects} path="/companyP&L/inwarding" exact />
			<PrivateRoute component={OpenPo} path="/companyP&L/openPo" exact />
			<PrivateRoute component={ProjectDocuments} path="/uploadProjectDocuments" exact />
			{/* <PrivateRoute component={SendToFinance} path="/design/sendToFinance" exact /> */}
			<PrivateRoute component={FinanceApprove} path="/finance" exact />
			<PrivateRoute component={Scoping} path="/scoping" exact />
			<PrivateRoute component={Inwarding} path="/inwarding" exact />
			<PrivateRoute component={StoreStocks} path="/store/stocks" exact />
			<PrivateRoute component={StorePayment} path="/store/payments" exact />
			<PrivateRoute component={InwardingForStore} path="/store/inwarding" exact />
			<PrivateRoute component={StoreOutwarding} path="/store/outwarding" exact />
			<PrivateRoute component={FactoryStocks} path="/factory/stocks" exact />
			<PrivateRoute component={InwardingForFactory} path="/factory/inwarding" exact />
			<PrivateRoute component={FactoryOutwarding} path="/factory/outwarding" exact />
			<PrivateRoute component={FactoryPayment} path="/factory/payments" exact />
			<PrivateRoute component={BOM} path="/bom" exact />
			<PrivateRoute component={User} path="/userManagement/users" exact />
			<PrivateRoute component={Roles} path="/userManagement/roles" exact />
			<PrivateRoute component={Department} path="/userManagement/departments" exact />
			<PrivateRoute component={Team} path="/userManagement/teams" exact />
			<PrivateRoute component={Vendors} path="/vendorManagement/vendors" exact />
			<PrivateRoute component={vendorPo} path="/vendor_po" exact />
			<PrivateRoute component={AllPo} path="/vendor_po/all" exact />
			<PrivateRoute component={MaterialTransfer} path="/materialTransfer" exact />
			<PrivateRoute component={ManageQTCustomer} path="/manage-customer/:customerId" exact />
			<PrivateRoute component={ManageCategory} path="/masterManagement/manageCategory" exact />
			<PrivateRoute component={ManageScopes} path="/masterManagement/manageScope" exact />
			<PrivateRoute component={ManageUnits} path="/masterManagement/manageUnit" exact />
			<PrivateRoute component={ManagePaymentModes} path="/masterManagement/managePaymentModes" exact />
			<PrivateRoute component={ManageSubCategory} path="/masterManagement/manageSubCategory" exact />
			<PrivateRoute component={ManageItems} path="/masterManagement/manageItems" exact />
			{/* <PrivateRoute component={ManageItems} path="/masterManagement/manageItems" exact /> */}
			<PrivateRoute component={ManageOrgRate} path="/masterManagement/manageOrgRate" exact />
			<PrivateRoute component={ManageProjectRate} path="/masterManagement/manageProjectRate" exact />
			<PrivateRoute component={MaterialPriceChangeDetails} path="/masterManagement/material-price-change-details" exact />
			<PrivateRoute component={ManageQuotation} path="/manageQuotations/:leadId" exact />
			{
				(userDetails.roles?.find(role =>role.name === "Operation Head" || role.name === "Finance Executive" || role.name === "Finance Manager") && 
				<>
			<PrivateRoute component={ApproveVendorAndMaterialMapping} path='/vendorManagement/approveVendorsAndMaterialMapping' exact />
			   </>
				)
			}	
			<PrivateRoute component={manageProjectLog} path="/project-logs/:projectId" exact />
			<PrivateRoute component={createLead} path="/create-new-lead" exact />
			<PrivateRoute component={createNewCustomer} path="/create-new-customer" exact />
			<PrivateRoute component={CxStageSetting} path="/customer-app-designstage-setting" exact />
			<PrivateRoute component={WhatsApp_Stages_Operations} path="/whatsapp-stages-operations" exact />
			<PrivateRoute component={WhatsApp_Stages_Marketing} path="/whatsapp-stages-marketing" exact />
			<PrivateRoute component={WhatsApp_Stages_Sales} path="/whatsapp-stages-sales" exact />

			<PrivateRoute component={marketingSource} path="/masterManagement/marketing-sources" exact />
			<PrivateRoute component={discountApproval} path="/discount-approval" exact />
			{/* {
			(userDetails?.roles?.find(role =>role.name === "Assistant Design Manager" || role.name === 'Operation Manager' || role.name === 'Finance Manager' || role.name === 'Design Manager' || role.name === 'Operation Design Manager' || role.name === 'DGM Ops') && 
			<> */}
				<PrivateRoute component={QtChangesApproval} path="/lead-quotation-changes-approval" exact />
			{/* </>
			)
			} */}
			<PrivateRoute component={marketingBudget} path="/set-marketing-budget" exact />
			<PrivateRoute component={ShowStatusInformation} path="/status-information/:statusName/:startDate/:endDate/:check/:isUser" exact />
			<PrivateRoute component={manageTarget} path="/set-team-target" exact />
			<PrivateRoute component={Location} path="/location" exact />
			<PrivateRoute component={ExperienceCenter} path="/experienceCenter" exact />
			<PrivateRoute component={managerCustomer} path="/customer/manager-customer" exact />
			<PrivateRoute component={ReminderReport} path="/reminder" exact />
			<PrivateRoute component={Home} path="/home" exact />
			<PrivateRoute component={AssignProjects} path="/customer/assign-lead" exact />
			<PrivateRoute component={MoveToDesign} path="/customer/move-to-design" exact />
			<PrivateRoute component={DesignerAssignmentView} path="/designer-assignment/:statusName/:startDate/:endDate/:userId/:isUser" exact />
			<PrivateRoute component={leadApprovalView} path="/lead-approval" exact />
			<PrivateRoute component={ComplimentaryApprovalView} path="/complimentary-approval" exact />
			<PrivateRoute component={LostLeadApprovalView} path="/lost-approvals" exact />
			<PrivateRoute component={leadCriteria} path="/lead-criteria" exact />
			<PrivateRoute component={FaqCreation} path="/faq-details" exact />
			<PrivateRoute component={DesignHoldView} path="/design-signoff-hold-projects" exact />
			<PrivateRoute component={CheckLists} path="/check-lists" exact />
			<PrivateRoute component={manageDiscount} path="/manage-discount" exact />
			{
				(userDetails.roles?.find(role => role.name === ROLENAME.OperationHead || role.name === "BOM Manager" ) && 
				<>
			<PrivateRoute component={BomMaterialForApproval} path="/bom/materialsForApproval" exact />
			   </>
				)
			}		
			<PrivateRoute component={LeadDesignToExecution} path="/lead-design-to-execution/:startDate/:endDate" exact />
			<PrivateRoute component={DesignHoldApprovalView} path="/lead-design-hold-approval" exact />
			<PrivateRoute component={ContractSignLeads} path="/contract-sign-leads" exact />
			<PrivateRoute component={VerifyDocuments} path="/verify-documents/:leadId" exact />
			<PrivateRoute component={ValidateContractsDocuments} path="/validate-contract-documents/:leadId" exact />
			<PrivateRoute component={SiteQcProjects} path="/siteqc/projects" exact />
			<PrivateRoute component={ManageSiteQcProjectLogs} path="/siteqc/project-detail/:projectId" exact />
			<PrivateRoute component={ReadyToDispatchProject} path="/ready-to-dispatch-project" exact />
			<PrivateRoute component={ManageReadyToDispatchProjectLogs} path="/ready-to-dispatch-project/log/:projectId" exact />
			{/* <PrivateRoute component={ManageExecutionProjectLogs} path="/underexecution-project/logs/:projectId" exact /> */}
			<PrivateRoute component={ManageExecutionProjectLogs} path="/:pageName/logs/:projectId" exact />
			<PrivateRoute component={ViewCustomerCheckList} path="/view-customer-checklist/:leadId" exact />
			<PrivateRoute component={ProjectMaterilData} path="/project-materials-details" exact />
			{/* <PrivateRoute component={CustomerPrivewQuotationView} path="/final-quotation-customer-approval" exact /> */}
			{/* <PrivateRoute component={ViewCustomerCheckList} path="/view-customer-checklist/:leadId" exact /> */}
			{/* <PrivateRoute component={TermsAndCondition} path="/terms-and-condition" exact /> */}
			<PrivateRoute component={TargetDetails} path="/target-details" exact />
			<PrivateRoute component={StageWiseLeads} path="/Sales-lead-wise-total-data" exact />
			<PrivateRoute component={customerSurveyFormsList} path="/view-customer-survey-forms" exact />
			<PrivateRoute component={Material_Return} path="/material_return" exact />
			{
				(userDetails.roles?.find(role => role.name === ROLENAME.OperationHead ) && 
				<>
			<PrivateRoute component={Approve_Material_Return} path="/approve_material_return" exact />
			   </>
				)
			}
			<PrivateRoute component={RealFormDetails} path="/customer-survey-form-details" exact />
			<PrivateRoute component={AddEditCheckList} path="/add-checklist" exact />
			<PrivateRoute component={FinalPaymentApproval} path="/final-payment-approval" exact />
			<PrivateRoute component={ImosCompletedProjects} path="/siteqc/completed-projects" exact />
			<PrivateRoute component={imosDashboardStageDetails} path="/imos-stage-projects/:imosStage" exact />
			<PrivateRoute component={ExecutionDashBoardDetail} path="/execution-stage-projects/:executionStage" exact />
			<PrivateRoute component={ExecutionDashBoardProjectDetail} path="/execution-dashboard-projects/:executionStage" exact />
			<PrivateRoute component={CHMLeads} path="/chm-leads" exact />
			<PrivateRoute component={ChmUserLeads} path="/chm-user-leads/:chmUserId" exact />
			<PrivateRoute component={UnderExecutionProject} path="/under-execution-project" exact />
			<PrivateRoute component={Completed} path="/project-completed" exact />
			<PrivateRoute component={CompletedMWP} path="/project-Completed-MWP" exact />
			<PrivateRoute component={Storelead} path="/store-lead" exact />
			<PrivateRoute component={vendorSOManage} path="/vendor-so-manage" exact />
			<PrivateRoute component={callCenterLogs} path="/call-center-logs" exact />
			<PrivateRoute component={InwardingInvoices} path="/inwarding-invoices" exact />

			{/* Routes for Statistics SubMenu */}
			<PrivateRoute component={BookingStats} path="/designstats/design-review-sheet" exact />
			<PrivateRoute component={MIS1} path="/mis1-dashboard" exact />
			<PrivateRoute component={LeadsGenerated} path="/leads-generated" exact />
			<PrivateRoute component={SourceOfLeadsDasboard} path="/source-of-leads-dashboard" exact />
			<PrivateRoute component={SalesSummary} path="/sales-summary" exact />
			<PrivateRoute component={DesignSummary} path="/design-summary" exact />
			<PrivateRoute component={InternalDSOSummary} path="/internal-dso-summary" exact />
			<PrivateRoute component={LostDataAnalysis} path="/lost-data-analysis" exact />
			<PrivateRoute component={DesignSignOffReview} path="/designSignOff-review" exact />
			<PrivateRoute component={DesignHoldAnalysis} path="/designHold-analysis" exact />
			<PrivateRoute component={MonthlyContractReview} path="/monthly-contract-review" exact />
			<PrivateRoute component={OpsReview} path="/ops-review" exact />
			<PrivateRoute component={PreProductionSummary} path="/pre-production-summary" exact />
			<PrivateRoute component={ProductionSummary} path="/production-summary" exact />
			<PrivateRoute component={SummaryOfDelivery} path="/summary-of-delivery" exact />
			<PrivateRoute component={UnderExecutionSummary} path="/under-execution-summary" exact />
			<PrivateRoute component={MWPSummary} path="/mwp-summary" exact />
			<PrivateRoute component={SummaryOfCompletion} path="/summary-of-completion" exact />
			<PrivateRoute component={StageValue} path="/stage-value" exact />
			<PrivateRoute component={DesignHoldRevokeAnalysis} path="/designHold-revoke-analysis" exact />
			{/* <PrivateRoute component={DesignSignOffStats} path="/designstats/design-sign-off" exact />
			<PrivateRoute component={MaterialDeliveryStats} path="/designstats/material-delivery" exact />
			<PrivateRoute component={ProjectCompletionStats} path="/designstats/project-completion" exact /> */}
			<PrivateRoute component={paymentApprover} path="/payment-approver" exact />
			<PrivateRoute component={DesignKickOff} path="/design_kick-off" exact />
			<PrivateRoute component={PendingInwardingApprovals} path="/finance-factory-inwarding/pendingInwardingApprovals" exact />
			<PrivateRoute component={NewInwardingApprovals} path="/finance-factory-inwarding/newInwardingApprovals" exact />
			<PrivateRoute component={EditedInwardingApprovals} path="/finance-factory-inwarding/editedInwardingApprovals" exact />
			<PrivateRoute component={RaisePaymentRequests} path="/finance-factory-inwarding/raisePaymentRequest" exact />
			<PrivateRoute component={PaymentRequestApproval} path="/finance-factory-inwarding/paymentRequestApproval" exact />
			<PrivateRoute component={InwardingFreightApproval} path="/finance-factory-inwarding/inwardingFreightApproval" exact />
			<PrivateRoute component={PaymentExcelDownload} path="/finance-factory-inwarding/paymentExcelDownload" exact />
			<PrivateRoute component={FactoryFinanceExecutive} path="/finance-factory-inwarding/factoryFinanceExecutive" exact />
			<PrivateRoute component={RejectedInwarding} path="/companyP&L/rejectedInwarding" exact />
			<PrivateRoute component={DownloadGRN} path="/companyP&L/download-grn" exact />
			<PrivateRoute component={POEditRequests} path="/companyP&L/poEditRequest" exact />
			<PrivateRoute component={POEditRequestsL1} path="/companyP&L/poEditRequestL1" exact />
			{/* <PrivateRoute component={pendingInwardingApprovals} path="/companyP&L/pendingInwardingApprovals" exact /> */}
			{/* <PrivateRoute component={MultiCheckCreatePo} path="/items-to-be-ordered" exact /> */}
			<PrivateRoute component={MultiCheckCreatePo} path="/items-below-MOQ" exact />
			<PrivateRoute component={WorkingDrawingReceived} path="/Working-Drawing-Received" exact />

			{/* Route for Factory Review Sheet Dashboard */}
			<PrivateRoute component={FactoryReviewSheet} path="/factory-review-sheet" exact />
			{ userDetails?.roles.find((role) => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User || role.name === ROLENAME.Admin || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager) && <PrivateRoute component={chmTicketForm} path="/CHM-Ticket-Creation" exact /> }
			{/* { !userDetails?.roles.find((role) => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User || role.name === ROLENAME.Admin || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager) && <PrivateRoute component={CHMuserDashboard} path="/AssignedCHMticket" exact /> } */}
			{/* { userDetails?.roles.find((role) => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User || role.name === ROLENAME.Admin || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager || role.name === ROLENAME.OperationHead) && <PrivateRoute component={CHMuserDashboard} path="/CHMuserDashboard" exact />} */}
			{ <PrivateRoute component={CHMuserDashboard} path="/CHMuserDashboard" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin) && <PrivateRoute component={ChmAddTicketCategory} path="/ChmAddTicketCategory" exact />}
			<PrivateRoute component={PaymentGenrateLink} path="/payment-genrate-link-approval" exact />
			<PrivateRoute component={CustomerLoginActivity} path="/customer-login-activity" exact />
			<PrivateRoute component={UserAccessManagement} path="/accessmanagement" exact />
			<PrivateRoute component={callCenterDashboard} path="/call_center_dashboard" exact />
			{ <PrivateRoute component={TaskManagementDashBoard} path="/Task-Management-DashBoard" exact />}
			{ <PrivateRoute component={TaskManagementNotesDashboard} path="/task-management-notes-dashBoard" exact />}

			{/* Removed Routes */}
			{/* <PrivateRoute component={OperationOne} path="/operation_one" exact /> */}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={leadToMeeting} path="/Lead-To-Meeting" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={meetingToOrder} path="/Meeting-To-Order" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={leadToOrder} path="/Lead-To-Order" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={leadInMarketing} path="/Lead-In-Marketing" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={leadsAssigned} path="/Lead-Assigned" exact />}

			<PrivateRoute component={SalesUserWonDealPending} path="/designer-assignment/Won-Deals-Pending-Designer-Assignment" exact />
			{/* Refund request approval component + positive negative CR raise dashboard component */}
			<PrivateRoute component={RefundRequestApprovalView} path="/refund-request-approval" exact />
			<PrivateRoute component={RaiseRefundRequest} path="/raise-refund-request" exact />
			<PrivateRoute component={RefundApproval} path="/refund-approval" exact />
			<PrivateRoute component={RaiseQuotationChangeRequest} path="/raise-positive-negative-cr-request" exact />
			{/* sales target and performance route */}
			<PrivateRoute component={SalesTarget} path="/target" exact />
	        <PrivateRoute component={PerformanceSales} path="/performance" exact />
			<PrivateRoute component={Incentives} path="/incentives" exact />
	        <PrivateRoute component={ParentComponent} path="/lead-builder" exact />
			{/* Route for PO/SO approved by kanishka dashboard */}
			<PrivateRoute component={ApproveStdRateOfMaterial} path="/po-so-standard-rate-approval" exact />
			<PrivateRoute component={Reports} path="/po-so-reports" exact />
			<PrivateRoute component={CurrentMonthPipelineDashboard} path="/current-month-pipeline" exact />
			<PrivateRoute component={ProjectionAcvDashboard} path="/projection-acv" exact />
			<PrivateRoute component={ExpectedClosureTracker} path="/expected-closure-tracker" exact />
			<PrivateRoute component={MeetingTrackerDashboard} path="/meeting-tracker" exact />
			<PrivateRoute component={StageReview} path="/stage-review" exact />
			<PrivateRoute component={ReminderDashboard} path="/reminder-dashboard" exact />
			<PrivateRoute component={TeamUserLogs} path="/team-user-logs" exact />
			<PrivateRoute component={MoveToMarketingApproval} path="/move-to-marketing-approval" exact />
			<PrivateRoute component={ProjectManagementDashboard} path="/project-management/dashboard" exact />
			<PrivateRoute component={CreateProject} path="/project-management/create-project" exact />
			<PrivateRoute component={Referral} path="/Referral" exact />
			<PrivateRoute component={CallRecordings} path="/call-detail-recordings" exact />
        	<PrivateRoute component={CallLogsForLead} path="/call-detail-recordings/:leadId" exact />

			<PrivateRoute component={MaterialsCheckListApprovals} path="/materials-checklist-approvals" exact />
			<PrivateRoute component={IncomingWhatsAppMessages} path="/incoming-whatsapp-messages/" exact />	
			<PrivateRoute component={TargetForDesignTeam} path="/target-for-design-team" exact />
            <PrivateRoute component={PerformanceForDesignTeam} path= "/performance-for-design-team" exact />
            <PrivateRoute component={IncentiveForDesignTeam} path="/incentive-for-design-team" exact />


			<PrivateRoute component={MyProjectManagementDashboard} path="/project-management/my-dashboard" exact />
            <PrivateRoute component={CapexProjectCreation} path="/project-management/create-capex-project" exact />
            <PrivateRoute component={CapexProjectApproval} path="/project-management/approve-capex-projects" exact />
            <PrivateRoute component={OverheadProjectCreation} path="/project-management/create-overhead-project" exact />
            <PrivateRoute component={OverheadProjectApproval} path="/project-management/approve-overhead-projects" exact />

			<PrivateRoute component={ScanPiece} path="/scan-piece" exact />
			<PrivateRoute component={InTransit} path="/in-transit-projects" exact />
			<PrivateRoute component={ScanPackageReport} path="/scanPackageLogs" exact />
			
			<PrivateRoute component={AutomationLeadDashboard} path="/automation-lead-summary/" exact />
			<PrivateRoute component={RedirectEC} path="/redirect-ec/" exact />
			<PrivateRoute component={logDetailed} path="/userManagement/logDetailed" exact />
			<PrivateRoute component={MonthlyConversionGoals} path="/set-monthly-conversion-goal" exact />
			<PrivateRoute component={inwardingLockDate} path="/inwarding-lock-date" exact />

		</>
	)
}

export default Index